import { memo } from "react";
// import classNames from "classnames";
// import { Tab, TabProps } from "../../../ui";
import { ValidationScope } from "../ValidationScope";

// import styles from "./style.module.scss";

type TabProps = unknown;

// todo implement

export const ValidationTab = memo<TabProps & { hasErrors?: boolean }>(({ hasErrors, ...props }) =>
  (
    <ValidationScope>
      {
        externalIsValid => {
          const isValid = externalIsValid && !hasErrors;
          return null;
          // return (
          //   <Tab
          //     strategy="hide"
          //     {...props}
          //     tabHeaderClassName={classNames(props.tabHeaderClassName, { [styles.invalidTab]: !isValid })}
          //     contentClassName={classNames(props.contentClassName, { [styles.invalidTabContent]: !isValid })}
          //     data-tab-valid={isValid}
          //   />
          // );
        }
      }
    </ValidationScope>
  ));

